import axios from "axios";
import Cookies from "js-cookie";

// Shared axios instance: auto-attaches the auth token to every request so call
// sites can't forget it (this class of bug — a call silently missing
// Authorization — only surfaced once the backend started actually enforcing
// authentication on every endpoint).
const httpClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

httpClient.interceptors.request.use((config) => {
  const token = Cookies.get("authToken");
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default httpClient;
